export const mess = (state) => state.alert.mess
